export default __webpack_public_path__ + "i/d230ab9e1e57e13d9944c3ce6bd1df49.png";